import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, } from '@angular/core';
import { Setting } from '@app-state';
import { enumMapper, USER_ICON_MAP, USER_ROBOT_ACCESS_FILTER, UserRobotAccess, UserType, } from '@models';
import { ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { UserService, } from '@services';
import { BehaviorSubject } from 'rxjs';
import { CheckPermissionsModalComponent, UserGroupImportModalComponent, UserModalComponent, } from './modals';
var UserWebAccessFilterValues = [{
        value: true,
        label: 'Enabled',
        translationKey: 'UserWebAccess_Enabled',
    }, {
        value: false,
        label: 'Disabled',
        translationKey: 'UserWebAccess_Disabled',
    }];
var UserStatusList = [{
        value: true,
        label: 'Active',
        translationKey: 'UserStatus_Active',
    }, {
        value: false,
        label: 'Inactive',
        translationKey: 'UserStatus_Inactive',
    }];
var USER_ROBOT_ACCESS_KEY = 'UserRobotAccess';
var ɵ0 = urlStateHandler;
var UsersPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UsersPageComponent, _super);
    function UsersPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        _this.UserIconMap = USER_ICON_MAP;
        _this.UserType = UserType;
        _this.statusList = UserStatusList;
        _this.webAccess = UserWebAccessFilterValues;
        _this.isWindowsAuthenticationEnabled = _this._appState.settings.get(Setting.isWindowsAuthEnabled);
        _this.editUserPermissions = ['Users.Edit'].concat(!_this._appState.settings.get(Setting.isModernFolderSystemEnabled) ? []
            : ['Robots.Create', 'Robots.Edit', 'Robots.Delete']);
        _this.isViewOnly = !!_this._appState.settings.get(Setting.isCloudRPAInstanceEnabled);
        _this.isMenuExpandable$ = _this._appState.user.permissions
            .isGranted('Users.Create & Roles.View | Units.View & Users.View & Roles.View');
        _this.userTypes = enumMapper(UserType, {
            resourceKey: 'UserType',
        });
        _this.robotAccess = enumMapper(UserRobotAccess, {
            resourceKey: USER_ROBOT_ACCESS_KEY,
            filterValueMap: USER_ROBOT_ACCESS_FILTER,
        });
        _this.defaultUserType = _this.userTypes
            .find(function (x) { return x.value === UserType.User.toString(); });
        _this._userService = _this._injector.get(UserService);
        return _this;
    }
    UsersPageComponent.prototype.ngOnInit = function () {
        // filter out unavailable types
        if (!this.isWindowsAuthenticationEnabled) {
            var AD_TYPES_1 = [
                UserType[UserType.DirectoryUser],
                UserType[UserType.DirectoryGroup],
            ];
            this.userTypes = this.userTypes.filter(function (userType) {
                return !AD_TYPES_1.includes(userType.label);
            });
            this.robotAccess = this.robotAccess.filter(function (robotAccess) {
                return robotAccess.label !== UserRobotAccess[UserRobotAccess.Group];
            });
        }
        else {
            this.defaultUserType = undefined;
        }
        this._expand$.next(['OrganizationUnits']);
    };
    UsersPageComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    UsersPageComponent.prototype.openModal = function (type, model) {
        var _this = this;
        this._modal
            .openModal(UserModalComponent, model, {
            data: {
                type: type,
            },
        })
            .afterClosedResult()
            .subscribe(function (res) {
            switch (res.type) {
                case 1 /* Add */:
                    _this._refresh$.next();
                    break;
                case 2 /* Update */:
                    var user = res.data;
                    _this._grid.dataManager.patchRow(user.id, user);
                    break;
            }
        });
    };
    UsersPageComponent.prototype.checkPermissions = function (model) {
        this._modal.openModal(CheckPermissionsModalComponent, model)
            .afterClosedResult()
            .subscribe();
    };
    UsersPageComponent.prototype.openImportModal = function () {
        var _this = this;
        this._modal
            .openModal(UserGroupImportModalComponent, {
            roles: undefined,
        })
            .afterClosedResult()
            .subscribe(function (res) {
            if (res.type !== 1 /* Add */) {
                return;
            }
            _this._refresh$.next();
        });
    };
    UsersPageComponent.prototype.setActive = function (user, active) {
        var _this = this;
        this.loading$.next(true);
        this._userService.setActive(user.id, active)
            .subscribe(function () {
            _this.loading$.next(false);
            user.isActive = active;
        }, function () {
            _this.loading$.next(false);
        });
    };
    UsersPageComponent.prototype.getLoginAttemptsLink = function (selectedRow) {
        return "/users/" + selectedRow.id + "/logins";
    };
    Object.defineProperty(UsersPageComponent.prototype, "allowDelete", {
        get: function () {
            var _this = this;
            return this._grid.selectionManager.hasValue() &&
                this._grid.selectionManager.selected.every(function (u) { return _this.userCanBeDeleted(u); });
        },
        enumerable: true,
        configurable: true
    });
    UsersPageComponent.prototype.userCanBeDeleted = function (user) {
        var currentUser = this._appState.user.value;
        if (!currentUser) {
            return false;
        }
        var isCurrentUser = currentUser.id === user.id;
        return ((user.rolesList == null || user.rolesList.indexOf('Administrator') < 0) && user.type !== UserType.Robot && !isCurrentUser);
    };
    UsersPageComponent.prototype.userCanBeDeactivated = function (user) {
        var currentUser = this._appState.user.value;
        if (!currentUser) {
            return false;
        }
        var isCurrentUser = currentUser.id === user.id;
        return user.type !== UserType.Robot && !isCurrentUser;
    };
    UsersPageComponent.prototype.robotAccessKey = function (user) {
        if (!user.mayHaveRobotSession) {
            return USER_ROBOT_ACCESS_KEY + '_Disabled';
        }
        if (!user.licenseType && user.type === UserType.DirectoryUser) {
            return USER_ROBOT_ACCESS_KEY + '_Group';
        }
        return USER_ROBOT_ACCESS_KEY + '_Enabled';
    };
    return UsersPageComponent;
}(ODataGridComponent));
export { UsersPageComponent };
export { ɵ0 };
